import React, { useEffect } from 'react'
import parse from 'html-react-parser'
import Image from 'next/image'

import { Text } from '@wartek-id/text'
import { Button } from '@wartek-id/button-v1'

import Header from 'app/BuktiKaryaPage/components/Header'
import { DocCollectionSection } from '../blocks/DocCollectionSection'
import { DocUploader } from '../blocks/DocUploader'
import { useBCKSInvitationCollection } from './useBCKSInvitationCollection'
import useKSPSTrackEvent from '../hooks/useKSPSTrackEvent'
import SectionInfoGaruda from '../components/SectionInfoGaruda'
import { useBCKSDesktopView } from 'app/BCKSPage/hooks/useBCKSDesktopView'
import { BCKSDesktopPageShell } from 'app/BCKSPage/components/BCKSDesktopPageShell'

export const BCKSInvitationCollectionPage = () => {
  const { KSPSTrackEvent } = useKSPSTrackEvent()
  const {
    handleCopyUrlClick,
    isDocValid,
    handleDocUpload,
    isUploading,
    docList,
    currentDoc,
    currentUploadingDoc,
    handleMutateDocList,
    handleRemoveTempDoc,
    isReviewMode,
    handleSaveDraft,
    handleNextStep,
    isDocDraftValid,
  } = useBCKSInvitationCollection()

  useEffect(() => {
    KSPSTrackEvent({
      event_name: 'enter_file_collection_page',
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const { isDesktop } = useBCKSDesktopView()
  const collectionSections = [
    {
      key: 'kinerja',
      title: 'Hasil Penilaian Kinerja',
      subtitle: 'Unggah hasil penilaian kinerja yang terbaru.',
      exampleFilePath: '/bcks/invitation/guide/kinerja',
      filePlaceholder: 'Pilih dokumen',
      fileData:
        isUploading && currentUploadingDoc.name === 'kinerja'
          ? { name: 'Hasil Penilaian Kinerja', url: 'dummyURL' }
          : { ...docList.kinerja },
      isLoading: isUploading && currentUploadingDoc.name === 'kinerja',
    },
    {
      key: 'police',
      title: 'Surat Keterangan Catatan Kepolisian (masa berlaku 6 bulan)',
      subtitle:
        'Unggah SK perilaku baik dari Polres setempat dengan masa berlaku 6 bulan sejak tanggal diterbitkan.',
      exampleFilePath: '/bcks/invitation/guide/police',
      filePlaceholder: 'Pilih dokumen',
      fileData:
        isUploading && currentUploadingDoc.name === 'police'
          ? { name: 'SKCK', url: 'dummyURL' }
          : { ...docList.police },
      isLoading: isUploading && currentUploadingDoc.name === 'police',
    },
    {
      key: 'managerial',
      title: 'Surat Keterangan Pengalaman Manajerial',
      subtitle:
        'Unggah surat keterangan atau keputusan dari Kepala Sekolah bahwa Anda memiliki 2 tahun pengalaman manajerial di satuan pendidikan, organisasi pendidikan, dan/atau komunitas pendidikan.',
      extraDesc:
        '*Khusus PPPK lampirkan juga bukti pengalaman kerja di dalam 1 dokumen yang sama',
      exampleFilePath: '/bcks/invitation/guide/managerial',
      filePlaceholder: 'Pilih dokumen',
      fileData:
        isUploading && currentUploadingDoc.name === 'managerial'
          ? { name: 'SK Manajerial', url: 'dummyURL' }
          : { ...docList.managerial },
      isLoading: isUploading && currentUploadingDoc.name === 'managerial',
    },
    {
      key: 'discipline',
      title: 'Surat Keterangan Bebas Hukuman Disiplin',
      subtitle:
        'Unggah surat dari Kepala Sekolah bahwa Anda tidak pernah dijatuhi hukuman kedisplinan (tidak perlu materai).',
      exampleFilePath: '/bcks/invitation/guide/discipline',
      filePlaceholder: 'Pilih dokumen',
      fileData:
        isUploading && currentUploadingDoc.name === 'discipline'
          ? { name: 'SK Bebas Hukuman', url: 'dummyURL' }
          : { ...docList.discipline },
      isLoading: isUploading && currentUploadingDoc.name === 'discipline',
    },
    {
      key: 'pakta_integritas',
      title: 'Pakta Integritas',
      subtitle: 'Unggah dokumen perjanjian yang ditandatangani.',
      exampleFilePath: '/bcks/invitation/guide/pakta_integritas',
      filePlaceholder: 'Pilih dokumen',
      fileData:
        isUploading && currentUploadingDoc.name === 'pakta_integritas'
          ? { name: 'Pakta Integritas', url: 'dummyURL' }
          : { ...docList.pakta_integritas },
      isLoading: isUploading && currentUploadingDoc.name === 'pakta_integritas',
    },
  ]

  const handleSaveDraftClick = () => {
    KSPSTrackEvent({
      event_name: 'click_file_collection_save_draft',
    })
    handleSaveDraft()
  }

  const handleNextStepClick = () => {
    KSPSTrackEvent({
      event_name: 'click_file_collection_next',
    })
    handleNextStep()
  }

  if (currentDoc.name) {
    return (
      <DocUploader
        setDoc={handleDocUpload}
        selectedDocMeta={currentDoc}
        docData={docList[currentDoc.name]}
        onDocUpload={handleMutateDocList}
        isReviewMode={isReviewMode}
        onBackClick={handleNextStep}
      />
    )
  }

  if (isDesktop) {
    return (
      <BCKSDesktopPageShell
        title="Pengumpulan berkas"
        pageLabel="Pengumpulan berkas"
      >
        <div className="pb-8">
          <div className="grid gap-6 lg:grid-cols-[minmax(0,1fr)_360px] lg:items-start">
            <div className="space-y-4 rounded-lg border border-outline-default p-5 bg-white">
              {collectionSections.map((section) => (
                <DocCollectionSection
                  key={section.key}
                  title={section.title}
                  subtitle={section.subtitle}
                  extraDesc={section.extraDesc}
                  exampleFilePath={section.exampleFilePath}
                  filePlaceholder={section.filePlaceholder}
                  fileData={section.fileData}
                  isLoading={section.isLoading}
                  onDocDeleteClick={() => {
                    handleRemoveTempDoc(section.key)
                  }}
                  onClick={() =>
                    handleDocUpload({
                      docName: section.key,
                    })
                  }
                />
              ))}
            </div>

            <div className="lg:sticky lg:top-24">
              <div className="rounded-lg border border-outline-default bg-white p-5 lg:p-6">
                <Text variant="heading-sm">Ringkasan pengumpulan</Text>
                <Text color="subdued" className="mt-2">
                  {isDocValid
                    ? 'Semua dokumen sudah terunggah. Anda dapat lanjut ke tahap cek berkas.'
                    : 'Lengkapi seluruh dokumen wajib. Anda tetap bisa menyimpan draf untuk melanjutkan nanti.'}
                </Text>

                <div className="mt-5 rounded-lg border border-outline-default bg-[#ECF5FE] p-4">
                  <Text variant="body-sm">
                    Catatan: Pastikan dokumen asli (
                    <strong>bukan fotokopi</strong>), ukuran{' '}
                    <strong>maks. 5 MB</strong>.
                  </Text>
                </div>

                <SectionInfoGaruda className="mt-5 rounded-xl" />

                <div className="mt-5 space-y-3">
                  <Button
                    fullWidth
                    size="lg"
                    color="black"
                    disabled={!isDocValid}
                    onClick={handleNextStepClick}
                  >
                    Lanjutkan
                  </Button>

                  <Button
                    fullWidth
                    size="lg"
                    color="white"
                    disabled={!isDocDraftValid}
                    onClick={handleSaveDraftClick}
                  >
                    Simpan Draf
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </BCKSDesktopPageShell>
    )
  }

  return (
    <div className="relative flex flex-col h-screen max-w-xl mx-auto">
      <Header title="Pengumpulan berkas" forceNavigateBack />

      <div className="bg-[#ECF5FE] p-4">
        <Text variant="body-sm">
          Catatan: Pastikan dokumen asli (<strong>bukan fotokopi</strong>),
          ukuran <strong>maks. 5 MB</strong>.
        </Text>
      </div>

      <div className="p-4">
        <section className="flex mb-4 p-4 border border-subdued rounded-lg md:hidden lg:hidden">
          <div className="w-36 mr-4">
            <Image
              layout="fixed"
              src="/images/img-typing-monitor.png"
              width={84}
              height={84}
              alt="Ilustrasi pengunggahan berkas"
            />
          </div>
          <div>
            <Text variant="body-sm" color="subdued">
              {parse(
                `Pengunggahan berkas dianjurkan melalui web <b>Ruang GTK</b>.`
              )}
            </Text>

            <Button
              className="mt-4"
              color="black"
              size="sm"
              onClick={() => {
                handleCopyUrlClick(window.location.origin)
              }}
            >
              Salin tautan
            </Button>
          </div>
        </section>

        {collectionSections.map((section) => (
          <DocCollectionSection
            key={section.key}
            title={section.title}
            subtitle={section.subtitle}
            extraDesc={section.extraDesc}
            exampleFilePath={section.exampleFilePath}
            filePlaceholder={section.filePlaceholder}
            fileData={section.fileData}
            isLoading={section.isLoading}
            onDocDeleteClick={() => {
              handleRemoveTempDoc(section.key)
            }}
            onClick={() =>
              handleDocUpload({
                docName: section.key,
              })
            }
          />
        ))}

        <SectionInfoGaruda className="mb-6" />

        <div className="flex flex-row items-center">
          <Button
            fullWidth
            className="mr-2"
            size="lg"
            color="white"
            disabled={!isDocDraftValid}
            onClick={handleSaveDraftClick}
          >
            Simpan Draf
          </Button>

          <Button
            fullWidth
            className="ml-2"
            size="lg"
            color="black"
            disabled={!isDocValid}
            onClick={handleNextStepClick}
          >
            Lanjutkan
          </Button>
        </div>
      </div>
    </div>
  )
}
